var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { component } from 'vuets';
var HasMsg = (function () {
    function HasMsg() {
        this.msg = 'Hello, world!';
    }
    HasMsg.prototype.append = function (suffix) {
        this.msg += suffix;
    };
    return HasMsg;
}());
export var Hello = (function (_super) {
    __extends(Hello, _super);
    function Hello() {
        _super.call(this);
        this.activate = 0;
        this.deactivate = 0;
    }
    Hello.activate = function (self) {
        self.activate++;
    };
    Hello.deactivate = function (self) {
        self.deactivate++;
        return true;
    };
    Hello.prototype.append = function (suffix) {
        _super.prototype.append.call(this, '?' + suffix);
    };
    return Hello;
}(HasMsg));
export default component({
    template: "\n<div>\n  <h3 @click=\"append('!')\">{{ msg }}</h3>\n  <div>\n    activate count: {{ activate }}\n  </div>\n  <div>\n    deactivate count: {{ deactivate }}\n  </div>\n</div>\n"
}, Hello, Hello.activate, Hello.deactivate);



//////////////////
// WEBPACK FOOTER
// ./src/Hello.ts
// module id = 2
// module chunks = 0